import dayjs from 'dayjs'
import { fetchSpringFestivalRanges } from '@/service'

/** 春运乘车日期区间（除夕至初七，由中控 holiday.info 动态加载） */
let springFestivalRangesCache = []
let springFestivalLoadPromise = null

/** 本地解析 holiday.info（接口失败时兜底） */
export function parseSpringFestivalRangesFromHolidayInfo(holidayInfo) {
  if (!holidayInfo || typeof holidayInfo !== 'object') return []
  const dateNameMap = {}
  Object.entries(holidayInfo).forEach(([date, info]) => {
    if (info?.name) dateNameMap[date] = info.name
  })
  const chuxiDates = Object.entries(dateNameMap)
    .filter(([, name]) => name === '除夕')
    .map(([date]) => date)
    .sort()
  const ranges = []
  chuxiDates.forEach((chuxi) => {
    const chuqi = Object.entries(dateNameMap)
      .filter(([date, name]) => name === '初七' && date >= chuxi)
      .map(([date]) => date)
      .find((date) => dayjs(date).diff(dayjs(chuxi), 'day') <= 15)
    if (chuqi) ranges.push({ start: chuxi, end: chuqi })
  })
  return ranges
}

export function setSpringFestivalRanges(ranges) {
  springFestivalRangesCache = Array.isArray(ranges) ? ranges : []
}

export function getSpringFestivalRanges() {
  return springFestivalRangesCache
}

/** 格式化为页面展示：如「1月28日至2月4日」，多段用顿号连接 */
export function formatSpringFestivalRangesText(ranges = springFestivalRangesCache) {
  if (!ranges?.length) return ''
  const parts = ranges
    .map((r) => {
      const start = dayjs(r.start)
      const end = dayjs(r.end)
      if (!start.isValid() || !end.isValid()) return ''
      return `${start.month() + 1}月${start.date()}日至${end.month() + 1}月${end.date()}日`
    })
    .filter(Boolean)
  return parts.join('、')
}

/** 从中控经 ticket-service 加载春运区间 */
export async function loadSpringFestivalRanges() {
  if (springFestivalLoadPromise) return springFestivalLoadPromise
  springFestivalLoadPromise = (async () => {
    try {
      const res = await fetchSpringFestivalRanges()
      if (res?.success && Array.isArray(res.data)) {
        setSpringFestivalRanges(res.data)
        return springFestivalRangesCache
      }
    } catch (e) {
      // 加载失败保持空列表
    }
    return springFestivalRangesCache
  })()
  return springFestivalLoadPromise
}

export function isSpringFestivalRidingDate(ridingDate) {
  if (!ridingDate) return false
  const d = dayjs(ridingDate).format('YYYY-MM-DD')
  return springFestivalRangesCache.some((r) => d >= r.start && d <= r.end)
}
